export enum EOrderStatusFinally {
  UNKNOW = "Unknown",
  PLACED = "Placed",
  TIMEOUTCANCELLED = "TimeOutCancelled",
  APPROVERDENIED = "ApproverDenied",
  CONSUMERCANCELLED = "ConsumerCancelled",
  DEALERACCEPTED = "DealerAccepted",
  DEALERDENIED = "DealerDenied",
  DEALERCANCELLED = "DealerCancelled",
  DRIVERASSIGNED = "DriverAssigned",
  DRIVERONTHEWAY = "DriverOnTheWay",
  DRIVERNEARBY = "DriverNearBy",
  DELIVERED = "Delivered",
  ETAUPDATED = "EtaUpdated",
}

export enum EStatusPayments {
  AWAITINGPAYMENT = "AwaitingPayment",
  PAYED = "Payed",
  DENIED = "Denied",
}
export enum EProfileOptions {
  administrator = 1,
  attendant = 2,
  deliveryman = 3,
  All = 99,
}

export enum EUserStatus {
  Active = 1,
  Inactive = 2,
}

export const EOrderStatusDescription: string = {
  [EOrderStatusFinally.UNKNOW]: "Desconhecido",
  [EOrderStatusFinally.PLACED]: "Pedido realizado",
  [EOrderStatusFinally.TIMEOUTCANCELLED]: "Pedido não aceito",
  [EOrderStatusFinally.APPROVERDENIED]: "Revenda recusou",
  [EOrderStatusFinally.CONSUMERCANCELLED]: "Cliente cancelou",
  [EOrderStatusFinally.DEALERACCEPTED]: "Revenda aceitou",
  [EOrderStatusFinally.DEALERDENIED]: "Revenda recusou",
  [EOrderStatusFinally.DEALERCANCELLED]: "Revenda cancelou",
  [EOrderStatusFinally.DRIVERASSIGNED]: "Motorista selecionado",
  [EOrderStatusFinally.DRIVERONTHEWAY]: "Em rota de entrega",
  [EOrderStatusFinally.DRIVERNEARBY]: "Motorista próximo",
  [EOrderStatusFinally.ETAUPDATED]: "ETA atualizado",
  [EOrderStatusFinally.DELIVERED]: "Finalizado",
} as any;
